
/* MARÓC 1986 - Documentos en carrito lateral Symmetry.
   Mantiene valores durante reemplazos AJAX del footer.
   No guarda documentos en localStorage/sessionStorage.
   No cambia ni borra observaciones (cart.note).
*/
(function () {
  'use strict';
  if (window.__marocDocumentosAjaxV2) return;
  window.__marocDocumentosAjaxV2 = true;

  var tipos = ['CC', 'CE', 'NIT', 'PAS', 'PPT', 'TI'];
  var pendiente = false;
  var memoria = { tipo: null, numero: null, abierto: null };
  var ultimoPanel = null;
  var restaurando = false;
  var programado = false;

  function obtener() {
    var drawer = document.querySelector('.js-cart-drawer');
    if (!drawer) return null;
    var panel = drawer.querySelector('[data-maroc-documentos]');
    if (!panel) return null;
    return {
      drawer: drawer,
      panel: panel,
      tipo: panel.querySelector('#maroc-doc-tipo'),
      numero: panel.querySelector('#maroc-doc-numero'),
      error: panel.querySelector('[data-maroc-doc-error]')
    };
  }

  function mostrarError(c, texto) {
    if (!c || !c.error) return;
    c.error.textContent = texto || '';
    c.error.hidden = !texto;
  }

  function abrir(c) {
    if (!c) return;
    c.panel.open = true;
    memoria.abierto = true;
    c.panel.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth'
    });
  }

  function capturar(c) {
    if (!c || restaurando) return;
    if (c.tipo) memoria.tipo = c.tipo.value;
    if (c.numero) memoria.numero = c.numero.value;
    memoria.abierto = c.panel.open;
  }

  // Recuperar los campos cuando AJAX reconstruye el carrito.
  function restaurar() {
    programado = false;
    var c = obtener();

    if (!c || !c.tipo || !c.numero) {
      ultimoPanel = null;
      return;
    }

    if (c.panel === ultimoPanel) return;

    ultimoPanel = c.panel;
    restaurando = true;

    try {
      if (memoria.tipo !== null) {
        c.tipo.value = memoria.tipo;
      }
      if (memoria.numero !== null) {
        c.numero.value = memoria.numero;
      }
      if (memoria.abierto !== null) {
        c.panel.open = memoria.abierto;
      }
    } finally {
      restaurando = false;
    }
  }

  function programarRestauracion() {
    if (programado) return;
    programado = true;
    window.requestAnimationFrame(restaurar);
  }

  programarRestauracion();

  var observador = new MutationObserver(
    programarRestauracion
  );

  observador.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Mantener el número mientras se escribe.
  document.addEventListener('input', function (e) {
    if (!e.target.matches(
      '.js-cart-drawer #maroc-doc-numero'
    )) return;

    var c = obtener();
    capturar(c);
    mostrarError(c, '');
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.matches(
      '.js-cart-drawer #maroc-doc-tipo, .js-cart-drawer #maroc-doc-numero'
    )) return;

    var c = obtener();
    capturar(c);
    mostrarError(c, '');
  }, true);

  // Conservar el estado abierto o cerrado.
  document.addEventListener('toggle', function (e) {
    if (
      e.target.matches &&
      e.target.matches(
        '.js-cart-drawer [data-maroc-documentos]'
      )
    ) {
      memoria.abierto = e.target.open;
    }
  }, true);

  function validar(c) {
    if (!c || !c.tipo || !c.numero) return false;

    var tipo = c.tipo.value.trim();
    var numero = c.numero.value.trim();

    if (tipos.indexOf(tipo) === -1) {
      abrir(c);
      mostrarError(
        c,
        'Selecciona el tipo de documento.'
      );
      c.tipo.focus();
      return false;
    }

    if (!numero) {
      abrir(c);
      mostrarError(
        c,
        'Ingresa tu número de documento.'
      );
      c.numero.focus();
      return false;
    }

    if (!/^[a-zA-Z0-9 .-]{3,30}$/.test(numero)) {
      abrir(c);
      mostrarError(
        c,
        'Revisa el número de documento (3 a 30 caracteres).'
      );
      c.numero.focus();
      return false;
    }

    mostrarError(c, '');
    return true;
  }

  function validarTerminos(c) {
    var casilla = c.drawer.querySelector(
      'terms-agreement input[type="checkbox"]'
    );

    if (casilla && !casilla.checked) {
      mostrarError(
        c,
        'Debes aceptar los términos y condiciones para continuar.'
      );
      casilla.focus();
      return false;
    }

    return true;
  }

  function ruta(path) {
    var base = (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) || '/';

    return base.replace(/\/?$/, '/') + path;
  }

  // Guardar la información en los atributos del carrito.
  async function guardar(c) {
    var tipo = c.tipo.value.trim();
    var numero = c.numero.value.trim();

    var respuesta = await fetch(
      ruta('cart/update.js'),
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Tipo de documento': tipo,
            'Numero de documento': numero
          }
        })
      }
    );

    if (!respuesta.ok) {
      throw new Error('Error al guardar');
    }

    var carrito = await respuesta.json();
    var a = carrito.attributes || {};

    if (
      a['Tipo de documento'] !== tipo ||
      a['Numero de documento'] !== numero
    ) {
      throw new Error('No se confirmó el guardado');
    }
  }

  // Interceptar la compra desde el carrito lateral.
  document.addEventListener('click', function (e) {
    var boton = e.target.closest(
      '.js-cart-drawer .checkout-buttons a[href]'
    );

    if (!boton) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (pendiente) return;

    var c = obtener();

    if (!c) {
      alert(
        'No se pudo cargar el formulario. Abre de nuevo el carrito.'
      );
      return;
    }

    capturar(c);

    if (!validar(c) || !validarTerminos(c)) {
      return;
    }

    pendiente = true;

    var destino = boton.href;

    boton.setAttribute('aria-disabled', 'true');
    boton.style.pointerEvents = 'none';
    boton.style.opacity = '0.6';

    guardar(c)
      .then(function () {
        window.location.assign(destino);
      })
      .catch(function () {
        pendiente = false;

        var actual = obtener() || c;
        var botonActual = actual.drawer.querySelector(
          '.checkout-buttons a[href]'
        );

        if (botonActual) {
          botonActual.removeAttribute('aria-disabled');
          botonActual.style.pointerEvents = '';
          botonActual.style.opacity = '';
        }

        abrir(actual);

        mostrarError(
          actual,
          'No pudimos guardar tus datos. Intenta nuevamente.'
        );
      });
  }, true);

})();
